import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

const defaultStyles = StyleSheet.create({
    remainingCount: {
        marginHorizontal: Theme.primaryMargin,
        paddingTop: 10
    },
    sectionList: {},
    sectionListItemContainer: {
        marginLeft: 20
    },
    sectionHeadercontainer: {
        marginTop: Device.isTabletOrWeb ? 25 : 25,
        marginHorizontal: 10
    },
    sectionText: {
        marginLeft: 10
    },
    playAssetContainer: {
        marginHorizontal: Theme.primaryMargin,
        marginTop: 28,
        marginBottom: 50,
        alignItems: 'center'
    },
    button: {
        minWidth: 250,
        maxWidth: 300,
        alignSelf: 'center',
        marginVertical: 20
    },
    outerContainer: { marginTop: -23, marginLeft: 10 },
    promoText: {
        ...fontStyles.title,
        textAlign: 'center',
        alignSelf: 'center'
    },
    greyText: {
        ...fontStyles.subtitle,
        maxWidth: Device.isTabletOrWeb ? '40%' : '80%',
        textAlign: 'center',
        alignSelf: 'center',
        marginBottom: 40
    },
    textsContainer: {
        marginTop: 50
    }
});

export default defaultStyles;
